(() => {
  if (!customElements.get('rorilio-lip-mix')) customElements.define('rorilio-lip-mix', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.root = this.closest('[data-lip-product]');
      this.form = document.getElementById(this.root.dataset.formId);
      this.variants = JSON.parse(this.root.querySelector('[data-lip-variants]').textContent);
      this.add = this.root.querySelector('[data-lip-atc]');
      if (!this.form || !this.add) return;
      this.addLabel = this.add.dataset.addLabel;
      this.unavailable = this.add.dataset.unavailableLabel;
      this.addEventListener('change', () => this.sync(true));
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-tone-value]');
        if (!option) return;
        const label = option.closest('label');
        const select = label.querySelector('select');
        select.value = option.dataset.toneValue;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        const menu = option.closest('details'); menu.open = false;
        menu.querySelector('summary').focus();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.querySelectorAll('.rlp-tone-menu[open]').forEach(menu => {menu.open=false;menu.querySelector('summary').focus();});
      });
      this.form.addEventListener('submit', e => {
        const match = this.sync(false);
        if (!match || !match.available || this.add.getAttribute('aria-disabled') === 'true') {
          e.preventDefault(); e.stopImmediatePropagation();
        }
      }, true);
      this.sync(false);
      new MutationObserver(() => this.syncSticky()).observe(this.add, {attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy']});
    }
    sync(updateURL) {
      const checked = this.querySelector('input[type=radio]:checked');
      const active = checked?.closest('[data-pack]');
      this.querySelectorAll('[data-pack]').forEach(card => {
        const chosen = card === active;
        card.classList.toggle('is-selected',chosen);
        card.querySelector('.rlp-tone-selectors').hidden = !chosen;
        card.querySelectorAll('select').forEach(s => s.disabled = !chosen);
      });
      const selects = active ? [...active.querySelectorAll('select')] : [];
      selects.forEach(select => {
        const label = select.closest('label'), cocoaShade = select.value === 'Cocoa Nude';
        label.querySelector('[data-tone-current]').textContent = select.value;
        const thumb = label.querySelector('[data-tone-thumb]'); thumb.dataset.shade = cocoaShade ? 'cocoa' : 'strawberry';
        const url = cocoaShade ? this.root.dataset.cocoaThumb : this.root.dataset.strawberryThumb;
        thumb.style.backgroundImage = url ? `url("${url.replace(/"/g, '%22')}")` : '';
        label.querySelectorAll('[data-tone-value]').forEach(option => {
          option.setAttribute('aria-pressed',String(option.dataset.toneValue === select.value));
          const image = option.querySelector('.rlp-tone-thumb');
          const src = option.dataset.toneValue === 'Cocoa Nude' ? this.root.dataset.cocoaThumb : this.root.dataset.strawberryThumb;
          image.style.backgroundImage = src ? `url("${src.replace(/"/g, '%22')}")` : '';
        });
      });
      const units = Number(checked?.value);
      const valid = selects.length === units && selects.every(s => ['Cocoa Nude','Sweet Strawberry'].includes(s.value));
      const cocoa = selects.filter(s => s.value === 'Cocoa Nude').length;
      const match = valid ? this.variants.find(v => v.units === units && v.cocoa === cocoa) : null;
      this.current = match;
      const id = this.form.querySelector('input[name=id]');
      id.value = match ? String(match.id) : '';
      id.disabled = !match?.available;
      this.add.disabled = !match?.available;
      this.add.querySelector('[data-lip-button-label]').textContent = match?.available ? this.addLabel : this.unavailable;
      this.root.dataset.selectedId = id.value;
      this.root.querySelector('[data-lip-status]').textContent = match ? `${units} ${units === 1 ? 'tubo' : 'tubos'} · ${match.price}` : this.unavailable;
      if (updateURL && match) {
        const url = new URL(location.href); url.searchParams.set('variant',String(match.id)); history.replaceState({},'',url);
      }
      this.syncSticky();
      return match;
    }
    syncSticky() {
      document.querySelectorAll('[data-lip-sticky]').forEach(bar => {
        if (bar.dataset.productId !== this.root.dataset.productId) return;
        const price = bar.querySelector('[data-lip-sticky-price]'); if (price) price.textContent = this.current?.price || '';
        const button = bar.querySelector('button');
        button.disabled = !this.current?.available || this.add.disabled || this.add.getAttribute('aria-disabled') === 'true' || this.add.getAttribute('aria-busy') === 'true';
      });
    }
  });
  function connectControls(scope = document) {
    scope.querySelectorAll('[data-source-slide]').forEach(button => {
      if (button.dataset.connected) return; button.dataset.connected='1';
      button.addEventListener('click',() => {
        const slides = button.closest('.rlp-source-gallery').querySelector('.rlp-source-slides');
        slides.scrollTo({left:slides.clientWidth*Number(button.dataset.sourceSlide),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      });
    });
    scope.querySelectorAll('[data-lip-review-track]').forEach(track => {
      if(track.dataset.pagesConnected) return; track.dataset.pagesConnected='1';
      const module=track.closest('.rlp-module'), cards=[...track.children];
      const dots=[...module.querySelectorAll('[data-lip-review-page]')];
      const arrows=[...module.querySelectorAll('[data-lip-carousel-direction]')];
      const pitch=()=>cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;
      const maximum=()=>Math.max(0,Math.ceil((track.scrollWidth-track.clientWidth)/pitch()-.01));
      const current=()=>Math.min(maximum(),Math.round(track.scrollLeft/pitch()));
      const update=()=>{const max=maximum(),page=current();dots.forEach((dot,i)=>{dot.hidden=i>max;dot.setAttribute('aria-current',String(i===page));});arrows.forEach(b=>b.disabled=Number(b.dataset.lipCarouselDirection)<0?page===0:page===max);};
      const go=page=>track.scrollTo({left:Math.min(maximum(),Math.max(0,page))*pitch(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i)));
      arrows.forEach(button=>{button.dataset.connected='1';button.addEventListener('click',()=>go(current()+Number(button.dataset.lipCarouselDirection)));});
      track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
    });
    scope.querySelectorAll('[data-lip-sticky] button').forEach(button => {
      if (button.dataset.connected) return; button.dataset.connected='1';
      button.addEventListener('click',() => {
        const bar = button.closest('[data-lip-sticky]');
        const root = [...document.querySelectorAll('[data-lip-product]')].find(x => x.dataset.productId === bar.dataset.productId);
        const form = root && document.getElementById(root.dataset.formId);
        const add = root?.querySelector('[data-lip-atc]');
        if (form && add && !add.disabled && add.getAttribute('aria-disabled') !== 'true') form.requestSubmit(add);
      });
    });
  }
  connectControls(); document.addEventListener('shopify:section:load',event => connectControls(event.target));
})();
